// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"98ad378a","137":"98f099dd","342":"e7bf6a70","355":"b0c6dba7","397":"2c8246f2","453":"1407b060","543":"01176bd9","642":"24e03a1a","881":"1491790c"}[chunkId] + ".chunk.js";
};